import { Flex } from '@mantine/core';
import { InvestmentDetailsCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsCard/InvestmentDetailsCard.tsx';
import { CardBodySkeleton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsCard/CardBodySkeleton.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

export const SidebarSkeleton = () => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex direction="column" gap="1rem">
			<InvestmentDetailsCard cardLabel={tMipManage('investment_summary_card.meta.title')}>
				<CardBodySkeleton count={4} />
			</InvestmentDetailsCard>

			<InvestmentDetailsCard
				cardLabel={tMipManage('investor_profile_card.investor_profile.card_label')}
			>
				<CardBodySkeleton count={5} />
			</InvestmentDetailsCard>

			<InvestmentDetailsCard
				cardLabel={tMipManage('investment_payment_card.payment.card_label')}
			>
				<CardBodySkeleton count={3} />
			</InvestmentDetailsCard>

			<InvestmentDetailsCard cardLabel={tMipManage('investment_vehicle_card.piv.card_label')}>
				<CardBodySkeleton count={3} />
			</InvestmentDetailsCard>
		</Flex>
	);
};
